export const endpointsToExcludeTheJWT = [];

export const queryKeys = {
  PROFILE: "profile",
  PUBLIC_PROFILE: "public_profile",
  BATTLES: "battles",
  RELATED_BATTLES: "related_battles",
  BATTLE: "battle",
  BATTLE_COMMENTS: "battle_comments",
  POST_BATTLE_COMMENT: "post_battle_comment",
  WALLET_ACTIVITIES: "wallet_activities",
  MY_BATTLES: "my_battles",
  USER_BATTLES: "user_battles",
  BATTLE_ACTIVITIES: "battle_activities",
  SPOTIFY_TOKEN: "spotify_token",
  SPOTIFY_SEARCH: "spotify_search",
  LEADERBOARDS: "leaderboards",
  LEADERBOARD_DETAILS: "leaderboard_details",
  HYPEBOARDS: "hypeboards",
  HYPEBOARD: "hypeboard",
  HYPEBOARD_BATTLES: "hypeboard_battles",
  HYPEBOARD_NAMES: "hypeboard_names",
  BATTLE_HYPEBOARD_SCORES: "battle_hypeboard_scores",
  BATTLE_STATS: "battle_stats",
  SWAPED_WIDGET: "swapped_widget",
};
